import { render } from "./CategoryProductDataList.vue?vue&type=template&id=168137e2&scoped=true"
import script from "./CategoryProductDataList.vue?vue&type=script&lang=js"
export * from "./CategoryProductDataList.vue?vue&type=script&lang=js"

import "./CategoryProductDataList.vue?vue&type=style&index=0&id=168137e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168137e2"]])

export default __exports__